// src/js/utils/translation-service.js

// Simple in-memory cache: lang → { textTrans, linkTrans }
const _translationsCache = {};

/**
 * Load (and cache) both text and link translations for the given language.
 * @param {string} lang
 * @returns {{
 *   textTrans: Record<string,string>,
 *   linkTrans: Record<string,string>
 * }}
 */
export async function loadMyTranslationsService(lang) {
  if (!_translationsCache[lang]) {
    // import both translator and router manager in parallel
    const [translatorMod, routesManagerMod] = await Promise.all([
      import(
        /* webpackChunkName: "text-translations" */
        /* webpackPrefetch: true */
        '../js/translator.js'
      ),
      import(
        /* webpackChunkName: "link-translations" */
        /* webpackPrefetch: true */
        '../js/router-routes-manager.js'
      ),
    ]);

    const _tempTextTranslator = await translatorMod.loadTextTranslations(lang);
    const _tempLinksTranslator = await routesManagerMod.initLinksTranslator(lang);
    const _tempFragmentsTranslator = await translatorMod.loadFragmentsTranslations(lang);

    _translationsCache[lang] = {
      _tempTextTranslator,
      _tempLinksTranslator,
      _tempFragmentsTranslator,
    };
  }

  return _translationsCache[lang];
}
